// Coalesces items that arrive one per event (a place per stream message)
// into one flush per animation frame, so fifty arrivals cost one dispatch
// and one render instead of fifty.
export function createFrameBatch<T>(flush: (items: T[]) => void) {
  let queue: T[] = []
  let frame: number | undefined

  const run = () => {
    frame = undefined
    const items = queue
    queue = []
    if (items.length > 0) flush(items)
  }
  const stop = () => {
    if (frame != null) cancelAnimationFrame(frame)
    frame = undefined
  }

  return {
    push(item: T) {
      queue.push(item)
      if (frame == null) frame = requestAnimationFrame(run)
    },
    // hands over whatever is queued now
    flush() {
      stop()
      run()
    },
    // drops whatever is queued: the stream was abandoned
    cancel() {
      stop()
      queue = []
    },
  }
}
